<app-subsection-title key="provider.tender.confirmation.title" />

@if (isLoading()) {
  <app-loading />
} @else {
  <form [formGroup]="decisionForm" class="space-y-6">
    <div class="space-y-4">
      <div class="flex items-start gap-3">
        <p-radioButton
          name="decision"
          [value]="TenderDecision.ACCEPT"
          [formControl]="decisionControl"
          inputId="accept"
        />
        <label for="accept" class="text-sm cursor-pointer">
          {{ dynamicAcceptText() | transloco }}
        </label>
      </div>

      <div class="flex items-start gap-3">
        <p-radioButton
          name="decision"
          [value]="TenderDecision.DECLINE"
          [formControl]="decisionControl"
          inputId="decline"
        />
        <label for="decline" class="text-sm cursor-pointer">
          {{ dynamicDeclineText() | transloco }}
        </label>
      </div>
    </div>

    <div class="text-red-500 text-sm">
      {{ 'provider.tender.confirmation.deadline' | transloco }}:
      <strong>{{ tenderDetails().submissionDate | appDate }}</strong>
    </div>

    @if (isAccepting()) {
      <h4 class="text-lg font-semibold">
        {{ 'provider.tender.confirmation.contactTitle' | transloco }}
      </h4>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <app-form-field
          id="providerContactSelect"
          fieldName="tenderContactPersonUuid"
          type="dropdownSelect"
          [dropDownOptions]="providerContactOptions()"
        ></app-form-field>
      </div>
    } @else {
      <app-tender-rejection-reason />
    }

    <!-- Submit Buttons -->
    <div class="flex justify-end gap-3 mt-6">
      @if (decisionForm.valid) {
        @if (isAccepting()) {
          <p-button
            [label]="'provider.tender.confirmation.acceptButton' | transloco"
            data-testid="accept-button"
            (onClick)="acceptTender()"
          />
        } @else {
          <p-button
            [label]="'provider.tender.confirmation.declineButton' | transloco"
            data-testid="reject-button"
            (onClick)="rejectTender()"
          />
        }
      }
    </div>
  </form>
}
